export default import.meta.ROLLDOWN_FILE_URL_knfL6E3oZJN2Af0ANlqNJg